<script lang="ts" setup>
import type { RoleDto } from "mws-identity-ts-sdk";
import { useRouter } from "vue-router";

import BaseButton from "@/common/components/BaseButton.vue";
import PageWrapper from "@/common/components/PageWrapper.vue";
import TableVue from "@/common/components/table/TableVue.vue";
import type { TableColumn } from "@/common/components/table/types";
import { useGetRolesQuery } from "@/roles/api/queries";

definePage({
  meta: {
    auth: ["Developer.Access"],
  },
});

const router = useRouter();

const columns: TableColumn<RoleDto>[] = [
  {
    key: "name",
    label: "Role",
    type: "link",
    pathConstructor: (item) => `roles/${item.id}`,
  },
];

const createRoleButtonClicked = async () => {
  await router.push("roles/create");
};

const { data: roles, isPending } = useGetRolesQuery();

const breadcrumbs = [
  {
    label: "Roles",
    to: "#",
  },
];
</script>

<template>
  <PageWrapper
    title="Role Management"
    :breadcrumb-links="breadcrumbs"
  >
    <template #actions>
      <BaseButton
        variant="primary"
        label="Create"
        @click="createRoleButtonClicked"
      />
    </template>
    <TableVue
      :columns="columns"
      :data="roles"
      :is-pending="isPending"
    />
  </PageWrapper>
</template>
